import { useContext, useEffect, useState } from "react";
import { CONTACT_US, GET_ALL_STATE_BY_COUNTY_ID, fetchData } from "../../components/Service";
import { useNavigate } from "../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../components/Context";
import _ from "lodash";
import { scrollTop } from "../../components/Helper";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { PhoneNumberUtil } from "google-libphonenumber";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

const phoneUtil = PhoneNumberUtil.getInstance();

const ContactUs = () => {
	const navigate = useNavigate();
	const [context] = useContext(Context);
	const [stateList, setStateList] = useState([]);
	const [selectedCountry, setSelectedCountry] = useState(null);
	const [selectedState, setSelectedState] = useState(null);
	const [defaultPhoneCountry, setDefaultPhoneCountry] = useState("us");
	const [fullPhone, setFullPhone] = useState("");

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		trigger,
		clearErrors,
		setError,
	} = useForm({ mode: "onChange" });

	const isPhoneValid = (phone, country_code) => {
		try {
			// if (!phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))) {
			// 	setError("mobile", { message: "Phone is invalid." });
			// 	setValue("mobile", "");
			// } else {
			// 	clearErrors("mobile");
			// 	setValue("mobile", phone);
			// }

			const onlyPhone = phone.replace(`+${country_code}`, "").trim();
			if (onlyPhone) {
				setValue("mobile", phone, { shouldValidate: true });
				clearErrors("mobile");
			} else {
				setValue("mobile", "");
				// setError("mobile", { message: "Phone is required." });
			}
		} catch (error) {
			return false;
		}
	};

	const getAllStateByCountryId = (country_id) => {
		let value = {
			country_id: country_id,
		};

		fetchData(GET_ALL_STATE_BY_COUNTY_ID, "POST", value, false, false, (res) => {
			if (res.status) {
				setStateList(res?.data);
			} else {
				setStateList([]);
			}
		});
	};

	const submitFrom = (data) => {
		fetchData(CONTACT_US, "POST", data, false, false, (res) => {
			if (res.status) {
				toast.success("Enquiry submitted successfully. We will contact you soon.");
				navigate("/");
			} else {
				toast.error(res?.message);
			}
		});
	};

	useEffect(() => {
		setValue("email_id", context?.user?.email ?? "");
		setValue("name", context?.user?.name ?? "");
		setValue("mobile", context?.user?.mobile ?? "");

		setFullPhone(context?.user?.mobile ?? "");
		
    setValue("country_id", context.user?.country_id);
    setSelectedCountry({
      value: context.user?.country_id,
      label: context?.countryList?.find(
        (item) => item?.id === context.user?.country_id
      )?.name,
    });
    getAllStateByCountryId(context.user?.country_id);
    setValue("state_id", context.user?.state_id);
    setSelectedState({
      value: context.user?.state_id,
      label: context?.stateList?.find(
        (item) => item?.id === context.user?.state_id
      )?.name,
    });
  
		scrollTop();
	}, []);
	return (
		<div className="col-lg-12">
			<div className="card card-forum">
				<div className="card-header usa-bg">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-3">
								<h4 class="text-white d-flex mb-0 py-2">Contact Us</h4>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body bg-white p-1 body-minh">
					<div className="row d-flex justify-content-between">
						<div className="col-lg-12">
							<h6 className="mb-3">Contact Details</h6>
						</div>
						<div className="col-lg-6 col-xl-7 mb-4 mb-lg-0">
							<form className="text-start mt-20 pb-30 needs-validation" onSubmit={handleSubmit(submitFrom)}>
								<div className="row">
									<div className="col-xl-6 col-lg-6 col-sm-6 mb-2">
										<label>
											Country 
											{/* <span className="text-danger">*</span> */}
										</label>

										<Select
											{...register("country_id", {
												// required: { value: true, message: "Select a country." },
											})}
											options={context?.countryList?.map((item) => ({
												label: item.name,
												value: item.id,
											}))}
											value={selectedCountry}
											onChange={(selected) => {
												setSelectedCountry(selected);
												getAllStateByCountryId(selected ? selected.value : "");
												setValue("country_id", selected ? selected.value : "");
												trigger("country_id");

												setSelectedState(null);
												setValue("state_id", "");
												trigger("state_id");

												context?.countryList?.forEach((item) => {
													if (item?.id == selected?.value) {
														setFullPhone("");
														setValue("mobile", "");
														setDefaultPhoneCountry(item?.code?.toLowerCase());
													}
												});
											}}
											placeholder="Select a country"
											className={`selectpicker p-0 ${errors.country_id && "is-invalid bdr-red"}`}
											classNamePrefix="react-select"
											isSearchable={false}
										/>
										{errors.country_id && <div class="invalid-feedback d-block">{errors.country_id.message}</div>}
									</div>

									<div className="col-xl-6 col-lg-6 col-sm-6 mb-2">
										<label>
											State 
											{/* <span className="text-danger">*</span> */}
										</label>

										<Select
											{...register("state_id", {
												// required: { value: true, message: "Select a state." },
											})}
											options={stateList?.map((item) => ({
												label: item.name,
												value: item.id,
											}))}
											value={selectedState}
											onChange={(selected) => {
												setSelectedState(selected);
												setValue("state_id", selected ? selected.value : "");
												trigger("state_id");
											}}
											placeholder="Select a state"
											className={`selectpicker p-0 ${errors.state_id && "is-invalid bdr-red"}`}
											classNamePrefix="react-select"
										/>
										{errors.state_id && <div class="invalid-feedback d-block">{errors.state_id.message}</div>}
									</div>
									<div className="col-xl-6 col-lg-6 col-sm-6 mb-2">
										<label>
											Name 
											<span className="text-danger">*</span>
										</label>
										<input
											className={`form-control bg-transparent ${errors.name && "is-invalid"}`}
											placeholder="Name"
											maxLength={50}
											{...register("name", {
												required: {
													value: true,
													message: "Name is required.",
												},
												pattern: {
													value: /^[A-Za-z ]+$/,
													message: "Only alphabetic characters are allowed.",
												},
											})}
											readOnly={context?.user?.name?  true:false}  
										/>
										{errors.name && <div class="invalid-feedback">{errors.name.message}</div>}
									</div>
									<div className="col-xl-6 col-lg-6 col-sm-6 mb-2">
										<label>
											Email 
											<span className="text-danger">*</span>
										</label>
										<input
											className={`form-control bg-transparent ${errors.email_id && "is-invalid"}`}
											placeholder="Email"
											type="email"
											maxLength={120}
											{...register("email_id", {
												required: {
													value: true,
													message: "Email is required.",
												},
												pattern: {
													value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
													message: "Email is invalid.",
												},
											})}
											readOnly={context?.user?.email?  true:false} 
										/>
										{errors.email_id && <div class="invalid-feedback">{errors.email_id.message}</div>}
									</div>
									<div className="col-xl-6 col-lg-6 col-sm-6 mb-2">
										<label>
											Phone
											 {/* <span className="text-danger">*</span> */}
										</label>
										<PhoneInput
											key={defaultPhoneCountry}
											defaultCountry={defaultPhoneCountry}
											forceDialCode={true}
											value={fullPhone}
											hideDropdown={true}
											disableCountryGuess={true}
											onChange={(phone, country) => {
												isPhoneValid(phone, country.country.dialCode);
												setFullPhone(phone);
												setValue("country_code", `+${country.country.dialCode}` || "+1");
											}}
											className={`form-control bg-transparent p-0 ${errors.mobile ? "is-invalid" : ""}`}
										/>
										<input
											type="hidden"
											{...register("mobile", {
												// required: "Phone is required.",
											})}
										/>
										{errors.mobile && <div className="invalid-feedback">{errors.mobile.message}</div>}
									</div>
									<div className="col-xl-6 col-lg-6 col-sm-6 mb-2">
										<label>
											The Subject of Your Message <span className="text-danger">*</span>
										</label>
										<input
											className={`form-control bg-transparent ${errors.subject && "is-invalid"}`}
											placeholder="The Subject of Your Message"
											{...register("subject", {
												required: {
													value: true,
													message: "Subject is required.",
												},
											})}
										/>
										{errors.subject && <div class="invalid-feedback">{errors.subject.message}</div>}
									</div>
									<div className="col-12 mb-2">
										<label>
											Message <span className="text-danger">*</span>
										</label>
										<textarea
											class={`form-control ${errors.message && "is-invalid"}`}
											rows="5"
											placeholder="Message"
											{...register("message", {
												required: {
													value: true,
													message: "Message is required.",
												},
												minLength: {
													value: 3,
													message: "Message must be at least 3 characters.",
												},
											})}
										></textarea>
										{errors.message && <div class="invalid-feedback d-block">{errors.message.message}</div>}
									</div>
								</div>
								<div className="d-block text-end ">
									<button className={`btn btn-default hover-up m-auto`} type="submit" name="submit">
										Submit
									</button>
								</div>
							</form>
						</div>
						<div className="col-lg-6 col-xl-4">
							<ul>
								<li>
									<div class="address mb-2">
										<p className="d-flex align-items-center">
											<span className="fi fi-ss-marker h4 mb-0 me-1"></span> <span class="fw-bold me-1"> Address: </span> Shibis, KM0 Mogadishu USA
										</p>
									</div>
								</li>
								<li>
									<div class="address mb-2">
										<p className="d-flex align-items-center">
											<span className="fi fi-br-mobile-notch h4 mb-0 me-1"></span> <span class="fw-bold me-1">Phone: </span> 844-435-7674
										</p>
									</div>
								</li>
								<li>
									<div class="address">
										<p className="d-flex align-items-center">
											<span className="fi fi-rr-at h4 mb-0 me-1"></span> <span class="fw-bold me-1">Email:</span> <a href="mailto:info@nris.com">info@nris.com</a>
										</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContactUs;
